import { useContext } from 'react';
import Context from '/business/shared/contexts/Context';
import type { PartialAppContext } from '/index.d';

const useAppContext = (): PartialAppContext => useContext(Context);
export default useAppContext;
